function ArrivedStatus() {
  return (
    <div className="w-[84px] h-[22px] flex items-center justify-center rounded-[11px] bg-[#80fc80] font-OpenSansRegular font-[400] text-titleColor text-[10px]">
      ARRIVED
    </div>
  );
}

export default ArrivedStatus;
